"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Topic = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const irlcg_1 = require("../ontologies/irlcg");
const Thing_1 = require("lincd-schema/lib/shapes/Thing");
const ActionTemplate_1 = require("./ActionTemplate");
const ScoreConfiguration_1 = require("./score_config/ScoreConfiguration");
let Topic = class Topic extends Thing_1.Thing {
    get scoreConfiguration() {
        return this.getOneAs(irlcg_1.irlcg.scoreConfiguration, ScoreConfiguration_1.ScoreConfiguration, true);
    }
    set scoreConfiguration(val) {
        this.overwrite(irlcg_1.irlcg.scoreConfiguration, val.namedNode);
    }
    get category() {
        return this.getValue(irlcg_1.irlcg.category);
    }
    set category(val) {
        this.overwrite(irlcg_1.irlcg.category, new models_1.Literal(val));
    }
    get actionTemplates() {
        return this.getAllAs(irlcg_1.irlcg.actionTemplate, ActionTemplate_1.ActionTemplate);
    }
};
exports.Topic = Topic;
/**
 * indicates that instances of this shape need to have this rdf.type
 */
Topic.targetClass = irlcg_1.irlcg.Topic;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.category,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Topic.prototype, "category", null);
exports.Topic = Topic = __decorate([
    package_1.linkedShape
], Topic);
//# sourceMappingURL=Topic.js.map